/* eslint-disable no-console */
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroupDirective, NgForm, ValidationErrors } from '@angular/forms';


import { TELEPHONE_CODES_LANGUAGES } from '../../../core/language/language.constants';
import { CountryData, IntlTelInputOptions } from '../model/intl-tel-input.model';
import { TranslateService } from '@ngx-translate/core';
import intlTelInput from 'intl-tel-input';

/**
 * Input mobile component
 * @description Angular component. Show form for insert a mobile number
 */
@Component({
  selector: 'ap-input-mobile',
  templateUrl: './ap-input-mobile.component.html',
  viewProviders: [
    NgForm,
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  styleUrls: ['ap-input-mobile.scss'],
})
export class InputMobileComponent implements AfterViewInit {
  @Input() controlName: string | number | null = '';
  @Input() public onlyLocalized!: boolean;
  @Input() public options: IntlTelInputOptions = {};

  @Output() onMobileSubmitted = new EventEmitter<string>();

  private _intlTelInput!: intlTelInput.Plugin;
  @ViewChild('intlTelInput') private readonly _inputElement!: ElementRef;

  constructor(private readonly languageService: TranslateService, private readonly controlContainer: ControlContainer) { }

  /**
   * @ignore
   */
  private static modifyCountryData(): void {
    (window as { intlTelInputGlobals: { getCountryData: () => CountryData[] } }).intlTelInputGlobals
      .getCountryData()
      .forEach((country: CountryData) => (country.name = country.name.replace(/.+\((.+)\)/, '$1')));
  }

  /**
   * After view initialization load IntlTelInput library and bind to input change
   */
  public ngAfterViewInit(): void {
    if (this.controlContainer.control && this.controlContainer.control.get('contact')) {
      this.controlContainer.control.get('contact')?.setValidators(this.validateMobileNumber.bind(this));
    }

    if (this.onlyLocalized) {
      InputMobileComponent.modifyCountryData();
    }

    this.options.autoHideDialCode = false;
    this.options.preferredCountries = TELEPHONE_CODES_LANGUAGES;
    this.options.nationalMode = true;
    this.options.autoPlaceholder = 'off';

    this.options.initialCountry = this.languageService.currentLang !== 'en' ? this.languageService.currentLang : 'gb';

    const intlTelInputInstance = intlTelInput;
    this._intlTelInput = intlTelInputInstance(this._inputElement.nativeElement, this.options);

    this.controlContainer.control?.get('contact')?.valueChanges.subscribe(() => {
      // send real value to controller
      if (this._intlTelInput.isValidNumber()) {
        this.onMobileSubmitted.emit(this._intlTelInput.getNumber());
      }
    });
  }

  /**
   * Valide mobile number inserted by user
   * @param control Abstract control contain the mobile number
   */
  validateMobileNumber(control: AbstractControl): ValidationErrors | null {
    // ! Check whether it is needed to pass value into isValidNumber method
    // isValidNumber for intlTelInput.Plugin does not require value as parameter.
    // This type assertion will be removed as soon as the check is done
    if ((this._intlTelInput as { isValidNumber: (value: string) => boolean }).isValidNumber(control.value)) {
      return null;
    }
    return { mobileError: 'error' };
  }

  /**
   * Submit mobile number and send to all observer
   */
  i18nizePhoneNumber(): void {
    if (this.controlContainer.control && this.controlContainer.control.get('contact')) {
      this.controlContainer.control.get('contact')?.updateValueAndValidity();
    }
    this.onMobileSubmitted.emit(this._intlTelInput.getNumber());
  }
}
